module.exports = __webpack_public_path__ + "img/hotmeter.aa0dea95.png";